import React, { useState } from 'react';
import { Input, Form, InputNumber, Modal, Button, Checkbox, Spin, notification } from 'antd';
import { handleFormChange, validateMessages } from '../../../shared/Utils';
import { useCreateBasicTaxiPricingMutation } from '../../../GraphQL/hooks/useCreateBasicTaxiPricingMutation';

const BasicTaxiPricingCreateModal = ({ isOpen, onRequestClose, updateList }) => {
    const [form] = Form.useForm();
    const [formError, setFormError] = useState(false);
    const [noMax, setNoMax] = useState(false);

    const formLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const { mutation, loading: creating } = useCreateBasicTaxiPricingMutation();

    const handleCommit = async () => {
        try {
            const values = await form.validateFields();

            if (values) {
                const payload = {
                    ...values,
                    maxDistance: noMax ? null : values.maxDistance,
                };

                mutation(payload)
                    .then(() => {
                        onRequestClose(false);
                        updateList();
                    })
                    .finally(() => {
                        notification.success({
                            message: 'Pricing updated successfully',
                            description: 'The pricing has been updated successfully.',
                        });
                        setNoMax(false);
                    })
                    .catch((err) => {
                        notification.error({
                            message: 'Failed to update pricing',
                            description: 'An error occurred while updating the pricing.',
                        });

                        console.error('Failed to update pricing:', err);
                    });
            } else {
                notification.error({
                    message: 'Form validation failed',
                    description: 'Please fill in all required fields correctly.',
                });
            }
        } catch (errorInfo) {
            notification.error({
                message: 'Form validation error',
                description: 'Please ensure all fields are filled out correctly.',
            });
            console.error('Failed: Form validation error', errorInfo);
        }
    };

    const handleCancel = () => {
        onRequestClose(false);
    };

    return (
        <Modal
            forceRender
            title="Add Range & pricing for Taxi"
            open={isOpen}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="create" type="primary" onClick={handleCommit} disabled={formError}>
                    Create Range & pricing
                </Button>,
            ]}
        >
            <Spin spinning={creating}>
                <Form
                    {...formLayout}
                    form={form}
                    autoComplete="off"
                    name="distance-tier-form"
                    onFieldsChange={() => setFormError(handleFormChange(form))}
                    validateMessages={validateMessages}
                >
                    <Form.Item name="rangeName" label="Range Name" rules={[{ required: true }]}>
                        <Input placeholder="Example: Short Ride" style={{ width: '50%' }} />
                    </Form.Item>

                    <Form.Item name="minDistance" label="Min Distance (km)" rules={[{ required: true }]}>
                        <InputNumber type="number" style={{ width: 200 }} placeholder="Min Distance in (km)" min={0} />
                    </Form.Item>

                    <Form.Item name="maxDistance" label="Max Distance (km)" rules={[{ required: !noMax }]}>
                        <InputNumber
                            type="number"
                            style={{ width: 200 }}
                            placeholder="Max Distance in (km)"
                            disabled={noMax}
                            min={0}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Checkbox checked={noMax} onChange={(e) => setNoMax(e.target.checked)}>
                            No maximum distance
                        </Checkbox>
                    </Form.Item>

                    <Form.Item name="pricePerKm" label="Price per km (TND)" rules={[{ required: true }]}>
                        <InputNumber
                            type="number"
                            style={{ width: 200 }}
                            step={0.001}
                            min={0}
                            placeholder="Price per km in TND"
                        />
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );
};

export default BasicTaxiPricingCreateModal;
